module.exports = __webpack_public_path__ + "static/media/sisipho.22e1913d.jpeg";